import React, {Component} from 'react'
import { FormControl, Form, Row, Col, FormGroup, ControlLabel, Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { Box } from 'reactjs-admin-lte'
import CKAutocomplete from 'component/element/CKAutocomplete'
import ConfirmPopup from 'component/element/ConfirmPopup'
import StockStore from 'stores/StockStore'
import WorkdocStore from 'stores/WorkdocStore'
import StockNewMixPaintDoc from './StockNewMixPaintDoc'
import Select from 'react-select'
import $ from 'jquery'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system')
class StockWaitMixPaintReport extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:[],barcodeMsgColor:'',barcodeMsg:'',car_registration_no:'',work_no:'',showTable:true,doc:{doc_no:''},mixrequest:{mixrequest_by:'',mixrequest_by_id:''},customerList:[],color_type_options:[],showConfirm:false,confirmIndex:undefined}
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
        this.loadData()
        this.loadWorkdocAutocompleteOfficer()
        $('body').on('click', ()=> { 
            if ($('.Select').hasClass('is-open')) {
              $('.table-responsive').css( "overflow-x", "initial" );
              $('.table-responsive').css( "overflow-y", "unset" );
            } else {
              $('.table-responsive').css( "overflow-x", "auto" );
              $('.table-responsive').css( "overflow-y", "" );
            }  
        });
    }
  }

  getRowClassName(in_queue_days,work_remain_days,park_status) {
    
    if ((in_queue_days*1>=3)||(work_remain_days<3)) {
        return 'stock-red-row'
    } else if ((in_queue_days*1>1&&in_queue_days*1<3)||(work_remain_days==3)) {
        return 'stock-orange-row'
    }
    return ''
  }

  loadData() {
    let color_type_options = [{label:'- '+this.props.messages['Select']+' -',value:''}]
    this.setState({loading:true})
    StockStore.loadMixpaintQueue((result)=>{
        result.color_type_options.forEach((item,index)=>{
            color_type_options.push({label:item,value:item})
        })
        this.setState({loading:false,data:result.data,barcodeMsgColor:'',barcodeMsg:'',car_registration_no:'',work_no:'',color_type_options:color_type_options})
    })
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          value: element.employee_id,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  onTextChange(field,e) {
    let {work_no,mixrequest} = this.state
    if (field==='work_no')
        work_no = e.target.value
    else if (field==='mixrequest_by') {
        mixrequest.mixrequest_by = e.target.value
        mixrequest.mixrequest_by_id = ''
    }    
    
    this.setState({work_no:work_no,mixrequest:mixrequest})
  }

  onMixrequestSelect(field,e) {
    let {mixrequest,customerList,data,work_no} = this.state
    let {messages} = this.props
    mixrequest.mixrequest_by = e
    const key = customerList.findIndex(x=>x.id==e)
    if (key!==-1) {
        mixrequest.mixrequest_by_id = customerList[key].emp_id
    }
    this.setState({mixrequest:mixrequest})
    let hasWorkNo = data.findIndex(x=>x.work_no==work_no)
    if (hasWorkNo===-1) {
        this.onSaveMixpaintQueue()
    } else {
        this._notificationSystem.addNotification({
            title:messages['Notice'],
            message: messages['Already Queue'],
            level: 'error',
            position:'tc'
        });
        this.setState({barcodeMsg:'',barcodeMsgColor:'',work_no:'',car_registration_no:''})
    }
  }

  onMixrequestPress(field,e) {
    if (e.charCode === 13) {
        let {mixrequest,customerList,data,work_no} = this.state
        let {messages} = this.props
        const key = customerList.findIndex(x=>x.label==mixrequest.mixrequest_by||x.emp_id==mixrequest.mixrequest_by)
        if (key!=-1) {
            mixrequest.mixrequest_by = customerList[key].label
            mixrequest.mixrequest_by_id = customerList[key].emp_id
            this.setState({mixrequest:mixrequest})
            let hasWorkNo = data.findIndex(x=>x.work_no==work_no)
            if (hasWorkNo===-1) {
                this.onSaveMixpaintQueue()
            } else {
                this._notificationSystem.addNotification({
                    title:messages['Notice'],
                    message: messages['Already Queue'],
                    level: 'error',
                    position:'tc'
                });
                this.setState({barcodeMsg:'',barcodeMsgColor:'',work_no:'',car_registration_no:''})
            }
        } else {
            mixrequest.mixrequest_by = ''
            mixrequest.mixrequest_by_id = ''
            this.setState({mixrequest:mixrequest})
            this._notificationSystem.addNotification({
                title: messages['Notice'],
                message: messages['Code Not Found']+' ' + mixrequest.mixrequest_by + ' '+messages['Please Try Again'],
                level: 'error',
                position: 'tc'
            });
        }
    }    
  }

  onSearchCarKeyPress(e) {
    let {work_no,car_registration_no,data} = this.state
    let {messages} = this.props
    if (e.charCode === 13) {
        e.preventDefault()  
        WorkdocStore.loadWorkdocCarInfo(e.target.value,(result)=>{
            let item = result.data    
            if(item.work_no!==''){   
                work_no = item.work_no         
                car_registration_no = item.car_registration_no              
                let hasWorkNo = data.findIndex(x=>x.work_no==work_no)
                if (hasWorkNo===-1) {
                    this.refs._mixrequest_by.onFocus()
                    this.setState({barcodeMsg:item.car_info,barcodeMsgColor:'color-green',work_no:work_no,car_registration_no:car_registration_no})
                } else {
                    this._notificationSystem.addNotification({
                        title:messages['Notice'],
                        message: messages['Already Queue'],
                        level: 'error',
                        position:'tc'
                    });
                    this.setState({barcodeMsg:'',barcodeMsgColor:'',work_no:'',car_registration_no:''})
                }
            }else{
                this.setState({barcodeMsg:messages['Worksheet Not Found'],barcodeMsgColor:'color-red',work_no:'',car_registration_no:''})
            }
        })
    }
  }

  onSaveMixpaintQueue() {
    let {work_no,mixrequest,data} = this.state
    let {messages} = this.props
    let postData = {work_no:work_no,mixrequest_by:mixrequest.mixrequest_by,mixrequest_by_id:mixrequest.mixrequest_by_id}
    WorkdocStore.loadWorkdocCarInfo(postData.work_no,(result)=>{
        let item = result.data    
        if(item.work_no===''){
            this.setState({barcodeMsg:messages['Worksheet Not Found'],barcodeMsgColor:'color-red',work_no:'',car_registration_no:''})
        } else {
            StockStore.saveMixpaintQueue('unfinished',postData,(result)=>{
                if (result.status==='OK') {
                    data.unshift(result.data)
                    this.setState({data:data})
                    this._notificationSystem.addNotification({
                        title:messages['Notice'],
                        message: messages['Add Item Successfully'],
                        level: 'info',
                        position:'tc'
                    });
                    mixrequest.mixrequest_by = ''
                    mixrequest.mixrequest_by_id = ''
                    this.setState({barcodeMsg:'',barcodeMsgColor:'',work_no:'',car_registration_no:'',mixrequest:mixrequest})
                }
            })
        }
    })
  }

  onJobStartClick(_item) {
    WorkdocStore.loadWorkdocCarInfo(_item.work_no,(result)=>{
        this.setState({showTable:false})
        let item = {work_no:result.data.work_no,car_registration_no:result.data.car_registration_no,car_info:result.data.car_info,bf_queue_id:_item.bf_queue_id,
            mixpaint_no:_item.mixpaint_no,colorcode:_item.colorcode,response_by:_item.response_by,mixed_by:_item.mixed_by,request_by:_item.mixrequest_by,request_mix_date:_item.request_mix_date,
            start_mix_date:_item.start_mix_date,end_mix_date:_item.end_mix_date}
        this.refs.stockNewMix.getWrappedInstance().onSetWorkNo(item)
    })
  }

  onDocClose() {
    let {doc} = this.state
    doc.doc_no = ''
    this.setState({showTable:true,doc:doc})
    this.loadData()
  }

  onColorTypeChange(index,item,e) {
    let {data} = this.state
    let {messages} = this.props
    data[index].mixcolor_type = e.value
    let postData = {bf_queue_id:item.bf_queue_id,mixcolor_type:e.value}
    this.setState({data:data})
    StockStore.saveMixcolorType(postData,(result)=>{
        if (result.status==='OK') {
            this._notificationSystem.addNotification({
                title:messages['Notice'],
                message: messages['Save Successfully'],
                level: 'info',
                position:'tc'
            });
        }
    })
  }

  onConfirmCancelClick() {
    let {data,confirmIndex} = this.state
    let {messages} = this.props
    let postData = {bf_queue_id:data[confirmIndex].bf_queue_id}
    StockStore.saveMixpaintQueue('cancel',postData,(result)=>{
        if (result.status==='OK') {
            this._notificationSystem.addNotification({
                title:messages['Notice'],
                message: messages['Cancel Successfully'],
                level: 'info',
                position:'tc'
            });
            this.loadData()
            this.setState({confirmIndex:undefined,showConfirm:false})
        }
    })
  }

  onJobCancelClick(index) {
    this.setState({showConfirm:true,confirmIndex:index})
  }

  renderForm() {
      let {work_no} = this.state
      let {messages} = this.props
      return(
        <Form>
            <Row>
                <Col md={1}>
                    <FormGroup>
                        <ControlLabel>{messages['Worksheet Number']}</ControlLabel>
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <FormGroup>
                        <FormControl 
                            value={work_no}
                            onKeyPress={this.onSearchCarKeyPress.bind(this)}
                            onChange={this.onTextChange.bind(this, 'work_no')}
                        />
                    </FormGroup>
                </Col>
                <Col md={2}>
                    <p className={this.state.barcodeMsgColor}>{this.state.barcodeMsg}</p>
                </Col>
                <Col md={1}>
                    <FormGroup>
                        <ControlLabel>{messages['Requester']}</ControlLabel>
                    </FormGroup>
                </Col>
                <Col md={3}>
                    <FormGroup>
                        <CKAutocomplete
                          top='-34px'
                          items={this.state.customerList}
                          value={this.state.mixrequest.mixrequest_by}
                          onChange={this.onTextChange.bind(this, 'mixrequest_by')}
                          onSelect={this.onMixrequestSelect.bind(this, 'mixrequest_by')}
                          onKeyPress={this.onMixrequestPress.bind(this, 'mixrequest_by')}
                          ref='_mixrequest_by'
                        />
                    </FormGroup>
                </Col>
            </Row>
        </Form>
      )
  }

  renderRowData() {
        let {data} = this.state
        let {messages} = this.props
        if (data.length===0) {
            return(<tr><td colSpan={12}>{messages['No Data']}</td></tr>)
        } else {
            return(
                data.map((item,index)=>
                    <tr key={index} className={this.getRowClassName(item.in_queue_days,item.work_remain_days,item.park_status)}>
                        <td className='text-center'>{item.added_date}</td>
                        <td className='text-center'>{item.in_queue_days}</td>
                        <td className='text-center'>{item.appointment_date}</td>
                        <td className='text-center'>{item.work_remain_days}</td>
                        <td className='text-center'>{item.work_no}</td>
                        <td className='text-center'>{item.car_registration_no}</td>
                        <td className='text-center'>{item.brand}</td>
                        <td className='text-center'>{item.model}</td>   
                        <td className='text-center'>{item.mixrequest_by}</td>
                        <td className='text-left'>
                            <Select 
                                clearable={false}
                                value={item.mixcolor_type}
                                options={this.state.color_type_options}
                                onChange={this.onColorTypeChange.bind(this,index,item)}
                            />
                        </td>                     
                        <td className='text-center'><Button onClick={this.onJobStartClick.bind(this,item)} bsStyle={'default'}><FontAwesome name={item.mixpaint_no=='0'?'clock-o':'pencil'} />&nbsp;{item.mixpaint_no=='0'?messages['Start']:messages['Edit']}</Button></td>
                        <td className='text-center'><Button onClick={this.onJobCancelClick.bind(this,index)} bsStyle={'default'}><FontAwesome name='ban' />&nbsp;{messages['Cancel']}</Button></td>
                    </tr>
                )
           )
        }
  }

  renderTable() {
        let {messages} = this.props
        return(
            <div className='table-responsive'>
                <table className='table table-hover table-bordered-solid' style={{minWidth:'1280px'}}>
                    <thead>
                        <tr>
                            <th style={{width:'100px'}} className='text-center'>{messages['Date Scan']}</th>
                            <th style={{width:'100px'}} className='text-center'>{messages['Wait Day']}</th>                            
                            <th style={{width:'100px'}} className='text-center'>{messages['Appointment Date']}</th>
                            <th style={{width:'110px'}} className='text-center'>{messages['Duration']}</th>
                            <th style={{width:'110px'}} className='text-center'>{messages['Worksheet']}</th>
                            <th style={{width:'110px'}} className='text-center'>{messages['Car Registration']}</th>
                            <th style={{width:'100px'}} className='text-center'>{messages['Brand']}</th>
                            <th style={{width:'100px'}} className='text-center'>{messages['Model']}</th>   
                            <th style={{width:'100px'}} className='text-center'>{messages['Requester']}</th>   
                            <th style={{width:'100px'}} className='text-center'>{messages['Type']}</th>                            
                            <th style={{width:'100px'}} className='text-center'>{messages['Start']}</th>
                            <th style={{width:'70px'}} className='text-center'>{messages['Cancel']}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderRowData(this)}
                    </tbody>
                </table>
            </div>
        )
  }
  
  render() {
    let {loading,showTable,doc} = this.state
    let {messages} = this.props
    return(
        <div>
            <div style={{display:(showTable?'':'none')}}>
                <Box loading={loading}>
                    <Box.Header border={true}>
                        <Box.Title>{messages['Queue Color Mixed']}&nbsp;<FontAwesome style={{cursor:'pointer'}} name='refresh' onClick={()=>{this.loadData()}} /></Box.Title>
                        <Box.Tools>
                        
                        </Box.Tools>
                    </Box.Header>
                    <Box.Body>
                        {this.renderForm()}
                        {this.renderTable()}
                    </Box.Body>
                </Box>   
            </div>       
            <StockNewMixPaintDoc 
                show={!showTable}
                doc={doc} 
                onClose={this.onDocClose.bind(this)}
                ref='stockNewMix'
            />
            <ConfirmPopup
                show={this.state.showConfirm}
                message={messages['Confirm Cancel Item']}
                onConfirm={this.onConfirmCancelClick.bind(this)}
                onHide={()=>{this.setState({showConfirm:false,confirmIndex:undefined})}}
            />
            <NotificationSystem ref="notificationSystem" />
        </div>    
    )
  }
}

StockWaitMixPaintReport.defaultProps = {
  show : false
}
export default connect(
    (state) => ({messages: state.message.view.stock.StockWaitMixPaintReport}),null,null,{withRef:true},
)(StockWaitMixPaintReport);


// WEBPACK FOOTER //
// ./src/view/stock/StockWaitMixPaintReport.js